module.exports = {
  siteTitle: 'Maurice van der Meijs',
  siteTitleAlt: 'Maurice van der Meijs Photography, Advertising, Commercial, Editorial, Sports Photographer', // This allows an alternative site title for SEO schema.
  publisher: 'Maurice van der Meijs', // Organization name used for SEO schema
  siteDescription:
    'Maurice van der Meijs is a commercial photographer specializing in portrait and sports, and is based in Utrecht , The Netherlands.',
  siteUrl: 'https://mauricevandermeijs.com', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  postsPerHomePage: 99, // Number of posts shown on the 1st page of of the index.js template (home page)
  postsPerPage: 99, // Number of posts shown on paginated pages
  author: 'Maurice van der Meijs', // Author for RSS author segment and SEO schema
  authorUrl: 'https://mauricevandermeijs.com/about', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@twitter', // Change for Twitter Cards
  shortTitle: 'Maurice', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 1200, // Change to the width of your default share image
  shareImageHeight: 630, // Change to the height of your default share image
  siteLogo: '/logos/logo-512.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#e9e9e9', // Used for Offline Manifest
  themeColor: '#121212', // Used for Offline Manifest
  copyright: 'Copyright © 2019 Maurice van der Meijs', // Copyright string for the RSS feed
}


